import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetCamerasProps } from '../Dashboard.types';

interface CamerasFiltersProps {
 control: Control<WidgetCamerasProps>;
 setValue: UseFormSetValue<WidgetCamerasProps>;
 errors: FieldErrors<WidgetCamerasProps>;
}

const CamerasFilters: React.FC<CamerasFiltersProps> = ({ control, setValue }) => {
 const { t } = useTranslation();
 const cameraFilter = JSON.stringify({
  fields: 'Id,Name',
  filters: [{ field: 'DeviceType', operator: 'eq', value: 'Camera' }],
  limit: 50,
 });

 return (
  <SelectApi<WidgetCamerasProps>
   name="camera"
   url="/api/iot/v1/"
   filter={cameraFilter}
   label={t('dashboard.filters.camera')}
   isEditable
   operator="contains"
   control={control}
   setValue={setValue}
  />
 );
};

export default CamerasFilters;
